import { SmsCampaignInfo } from 'interface/WizardV3';

export const declinedRegistrationData = (smsCampaignInfo: SmsCampaignInfo) => {
  if (Array.isArray(smsCampaignInfo?.data) && smsCampaignInfo.data.length > 0) {
    const declinedData = smsCampaignInfo.data.filter(
      (campaignInfo) => campaignInfo.campaignStatus === 'DECLINED',
    );
    const isDeclined = declinedData.length > 0;
    return { declinedData, isDeclined };
  }
  return { declinedData: [], isDeclined: false };
};
